
export const BILL_PROCESSING_REPORT_ACTION = 'BILL_PROCESSING_REPORT_ACTION'
export const BILL_PROCESSING_REPORT_ACTION_SUCCESS = 'BILL_PROCESSING_REPORT_ACTION_SUCCESS'



export const BILL_PROCESSING_FILTER_ACTION = 'BILL_PROCESSING_FILTER_ACTION'
export const BILL_PROCESSING_FILTER_ACTION_SUCCESS = 'BILL_PROCESSING_FILTER_ACTION_SUCCESS'

export const BILL_PROCESSING_REPORT_ERROR_ACTION = 'BILL_PROCESSING_REPORT_ERROR_ACTION'